import { render, staticRenderFns } from "./RequiredInput.vue?vue&type=template&id=c381dcd6&"
import script from "./RequiredInput.vue?vue&type=script&lang=ts&"
export * from "./RequiredInput.vue?vue&type=script&lang=ts&"
import style0 from "./RequiredInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports